import {useContext, useEffect, useState} from "react";
import Spinner from "../../Spinner";
import customerContext from "../../../contexts/customers/customerContext";
import customerTaskContext from "../../../contexts/customerTask/customerTaskContext";
import Error from "../../alerts/Error";
import purchaseOrderContext from "../../../contexts/purchaseOrders/purchaseOrderContext";

const initialCustomerTask = {
	code: '',
	name: '',
	description: '',
	customerId: '',
	estimatedInvoiceValue: '',
	dueDate: '',
	expectedDueDate: '',
	purchaseOrderId: '',
	subCustomers: [],
};

function AddCustomerTask() {
	const [customerTask, setCustomerTask] = useState(initialCustomerTask);
	const {loading, createCustomerTask} = useContext(customerTaskContext);
	const {customers} = useContext(customerContext);
	const {purchaseOrders} = useContext(purchaseOrderContext);
	const [error, setError] = useState(null);

	async function onSubmit(evt) {
		evt.preventDefault();
		setError(null);

		if (customerTask.estimatedInvoiceValue === '0' && !customerTask.nonBillable) {
			setError("Estimated final pricing cannot be 0 if the task is billable.");
			return;
		}

		try {
			await createCustomerTask(customerTask);
		}
		catch (e) {
			console.error(e);
			setError(e.message);
		}
		setCustomerTask(initialCustomerTask);
	}

	function onChange(evt) {
		switch (evt.target.type) {
			case "checkbox":
				if (evt.target.id === 'nonBillable' && evt.target.checked) {
					setCustomerTask({
						...customerTask,
						estimatedInvoiceValue: '0',
						purchaseOrderId: '',
						[evt.target.id]: evt.target.checked
					});
				} else {
					setCustomerTask({
						...customerTask,
						[evt.target.id]: evt.target.checked
					});
				}
				break;
			case "select-multiple":
				setCustomerTask({
					...customerTask,
					[evt.target.id]: Array.from(evt.target.selectedOptions, option => option.value)
				});
				break;
			default:
				setCustomerTask({
					...customerTask,
					[evt.target.id]: evt.target.value
				});
		}
	}

	return (
		<div>
			<button className={"btn btn-success"} data-bs-toggle={"modal"} data-bs-target={"#addCustomerTaskModal"}>Add project</button>
			<div className={"modal fade"} id={"addCustomerTaskModal"} tabIndex="-1" aria-labelledby="addCustomerTaskModalLabel" aria-hidden="true">
				<div className={"modal-dialog modal-lg"}>
					<div className={"modal-content"}>
						<form onSubmit={onSubmit}>
							<div className={"modal-header"}>
								<h5 className={"modal-title"} id={"addCustomerTaskModalLabel"}>Add project</h5>
								<button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"} />
							</div>
							<div className={"modal-body"}>
								{error && <Error message={error} /> }
								<div className="row mb-3">
									<div className={"col"}>
										<label htmlFor="code" className={"form-label"}>Code:</label>
										<input type="text" id={"code"} value={customerTask.code} className={"form-control"} placeholder={"00_Other"} required={true} onChange={onChange}/>
									</div>
									<div className={"col"}>
										<label htmlFor="name" className={"form-label"}>Name:</label>
										<input type="text" id={"name"} value={customerTask.name} className={"form-control"} placeholder={"WBQA policy violation: answer passage"} required={true} onChange={onChange}/>
									</div>
								</div>
								<div className="mb-3">
									<label htmlFor="description" className={"form-label"}>Description:</label>
									<textarea id={"description"} className={"form-control"} placeholder={"Have to be invoiced by GlobalMe -- WBQA policy violation: answer passage"} required={true} value={customerTask.description} onChange={onChange}/>
								</div>
								<div className={"mb-3 row"}>
									<div className="col">
										<label htmlFor="customerId" className={"form-label"}>Customer:</label>
										<select id="customerId" className={"form-select"} required={true} value={customerTask.customerId} onChange={onChange}>
											<option value="">Select an option</option>
											{customers.filter(value => !value.archived).map(value => {
												return <option key={value.id} value={value.id}>{value.firstName}</option>;
											})}
										</select>
									</div>
									{customerTask.customerId &&
										<div className="col">
											<label htmlFor="subCustomers" className={"form-label"}>Customer Contact(s):</label>
											<select id="subCustomers" className={"form-select"} multiple={true} required={false} value={customerTask.subCustomers} onChange={onChange}>
												{customers.find(value => value.id === customerTask.customerId).subCustomers.map(value => {
													return <option key={value.id} value={value.id}>{value.fullName}</option>;
												})}
											</select>
										</div>
									}
								</div>
								<div className={"mb-3"}>
									<label htmlFor="purchaseOrderId" className={"form-label"}>PO number:</label>
									<select id="purchaseOrderId" className={"form-select"} required={true} value={customerTask.purchaseOrderId} disabled={customerTask.nonBillable} onChange={onChange}>
										<option value="">Select an option</option>
										{purchaseOrders.filter(value => !value.archived).map(value => {
											return <option key={value.id} value={value.id}>{`${value.number} -> ${value.description}`}</option>;
										})}
									</select>
								</div>
								<div className="row mb-3">
									<div className={"col"}>
										<label htmlFor="dueDate" className={"form-label"}>Due date for quoting:</label>
										<input type="date" id={"dueDate"} className={"form-control"} value={customerTask.dueDate} required={false} onChange={onChange}/>
									</div>
									<div className={"col"}>
										<label htmlFor="expectedDueDate" className={"form-label"}>Expected due date:</label>
										<input type="date" id={"expectedDueDate"} className={"form-control"} value={customerTask.expectedDueDate} required={false} onChange={onChange}/>
									</div>
								</div>
								<div className="row mb-3">
									<div className="col">
										<label htmlFor="estimatedInvoiceValue" className={"form-label"}>Estimated final pricing:</label>
										<input type="number" id={"estimatedInvoiceValue"} value={customerTask.estimatedInvoiceValue} className={"form-control"} required={false} disabled={customerTask.nonBillable} onChange={onChange}/>
									</div>
									<div className="form-check col mt-5">
										<input className="form-check-input" type="checkbox" value="" name="nonBillable" id={"nonBillable"} checked={customerTask.nonBillable} onChange={onChange}/>
										<label className="form-check-label" htmlFor={"nonBillable" + customerTask.id}>
											Non billable to client
										</label>
									</div>
								</div>
							</div>
							<div className={"modal-footer justify-content-between"}>
								<button type={"button"} className={"btn btn-secondary"} data-bs-dismiss={"modal"}>Close</button>
								<button type={"submit"} className={"btn btn-success"}>{loading ? <Spinner />: 'Add project'}</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
}

export default AddCustomerTask;
